import {
  FILTER_TYPE__PROPERTY,
  FILTER_CONDITION__TEXT,
  FILTER_CONDITION__INCLUDE,
  FILTER_CONDITION__EXCLUDE,
  FILTER_CONDITION__DATE_EQUALS,
  FILTER_CONDITION__DATE_AFTER,
  FILTER_CONDITION__DATE_BEFORE,
  FILTER_CONDITION__DATE_SAME_OR_AFTER,
  FILTER_CONDITION__DATE_SAME_OR_BEFORE,
  FILTER_CONDITION__EQUALS,
  FILTER_CONDITION__MINIMUM,
  FILTER_CONDITION__MAXIMUM,
} from '../../../../common/constants';

/**
 * Filter presets for EAPP Digest logs tab (same FiltersToolbar UX as Triggered).
 */
const digestLogsDefaultFilters = [
  {
    name: 'Digest name',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__TEXT,
    settings: {
      id: 'reportName',
    },
    meta: {
      conditions: [FILTER_CONDITION__TEXT],
    },
  },
  {
    name: 'Status',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__INCLUDE,
    settings: {
      id: 'status',
    },
    meta: {
      noSearch: true,
      conditions: [FILTER_CONDITION__INCLUDE, FILTER_CONDITION__EXCLUDE],
      jsonSchema: {
        type: 'array',
        items: {
          oneOf: [
            { const: 'SUCCESS', title: 'SUCCESS' },
            { const: 'PARTIAL_FAILED', title: 'PARTIAL FAILED' },
            { const: 'FAILED', title: 'FAILED' },
            { const: 'RETRYING', title: 'RETRYING' },
            { const: 'initiated', title: 'Initiated' },
            { const: 'failed', title: 'Failed (legacy)' },
            { const: 'sent', title: 'Sent (legacy)' },
          ],
        },
      },
    },
  },
  {
    name: 'Failure reason',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__INCLUDE,
    settings: {
      id: 'failureReasons',
    },
    meta: {
      noSearch: true,
      conditions: [FILTER_CONDITION__INCLUDE, FILTER_CONDITION__EXCLUDE],
      jsonSchema: {
        type: 'array',
        items: {
          oneOf: [
            {
              const: 'Temporary platform issue',
              title: 'Temporary platform issue',
            },
            {
              const: 'Charts/analytics temporarily unavailable',
              title: 'Charts/analytics temporarily unavailable',
            },
            {
              const: 'Email delivery problem',
              title: 'Email delivery problem',
            },
            {
              const: 'No valid recipients',
              title: 'No valid recipients',
            },
            {
              const: 'Unexpected error',
              title: 'Unexpected error',
            },
          ],
        },
      },
    },
  },
  {
    name: 'Scheduled date',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__DATE_EQUALS,
    settings: {
      id: 'scheduledTime',
    },
    meta: {
      conditions: [
        FILTER_CONDITION__DATE_EQUALS,
        FILTER_CONDITION__DATE_SAME_OR_AFTER,
        FILTER_CONDITION__DATE_SAME_OR_BEFORE,
        FILTER_CONDITION__DATE_AFTER,
        FILTER_CONDITION__DATE_BEFORE,
      ],
    },
  },
  {
    name: 'Last attempted date',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__DATE_EQUALS,
    settings: {
      id: 'lastAttemptAt',
    },
    meta: {
      conditions: [
        FILTER_CONDITION__DATE_EQUALS,
        FILTER_CONDITION__DATE_SAME_OR_AFTER,
        FILTER_CONDITION__DATE_SAME_OR_BEFORE,
        FILTER_CONDITION__DATE_AFTER,
        FILTER_CONDITION__DATE_BEFORE,
      ],
    },
  },
  {
    name: 'Attempt count',
    type: FILTER_TYPE__PROPERTY,
    condition: FILTER_CONDITION__MINIMUM,
    state: {
      threshold: 1,
    },
    settings: {
      id: 'attemptCount',
    },
    meta: {
      conditions: [
        FILTER_CONDITION__EQUALS,
        FILTER_CONDITION__MINIMUM,
        FILTER_CONDITION__MAXIMUM,
      ],
    },
  },
];

export default digestLogsDefaultFilters;
